import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TAB_TO_PATH_MAP } from "./constants";
import { NavbarTabsProps, NavbarTab } from "./types";
import { FleetIcon, UnitIcon } from "@/components/Icons/index";
import CategoryIcon from "@/assets/images/logos/category.svg";

export const TenantHeaderTabs: React.FC<NavbarTabsProps> = ({
  activeTab,
  onTabClick,
  isMobile = false,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const tabs: NavbarTab[] = [
    {
      name: "Dashboard",
      displayName: t("navbar.tabs.dashboard"),
      icon: (
        <img
          src={CategoryIcon}
          alt="Category"
          className={isMobile ? "h-4 w-4" : "h-[13px]"}
        />
      ),
      path: TAB_TO_PATH_MAP.Dashboard,
    },
    {
      name: "Fleet",
      displayName: t("navbar.tabs.fleet"),
      icon: isMobile ? <FleetIcon className="h-4 w-4" /> : undefined,
      path: TAB_TO_PATH_MAP.Fleet,
    },
    {
      name: "Unit",
      displayName: t("navbar.tabs.unit"),
      icon: isMobile ? <UnitIcon className="h-4 w-4" /> : undefined,
      path: TAB_TO_PATH_MAP.Unit,
    },
  ];

  const handleTabClick = (tabName: string) => {
    onTabClick(tabName);
    const path = TAB_TO_PATH_MAP[tabName as keyof typeof TAB_TO_PATH_MAP];
    if (path) {
      navigate(path);
    }
  };

  if (isMobile) {
    return (
      <div className="space-y-2">
        {tabs.map((tab) => (
          <button
            key={tab.name}
            onClick={() => handleTabClick(tab.name)}
            className={`w-full flex items-center gap-3 p-4 rounded-lg transition-all duration-300 text-left ${
              activeTab === tab.name
                ? "bg-white/20 text-white border-l-4 border-[#1DE4D4]"
                : "text-gray-400 hover:text-gray-300 hover:bg-white/10"
            }`}
          >
            {tab.icon && (
              <div
                className={`${
                  activeTab === tab.name ? "text-[#1DE4D4]" : "text-gray-400"
                }`}
              >
                {tab.icon}
              </div>
            )}
            <span className="font-medium">{tab.displayName}</span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center ml-8">
      <div>
        <ul className="flex font-medium text-center !text-sm">
          {tabs.map((tab) => (
            <li key={tab.name}>
              <button
                onClick={() => handleTabClick(tab.name)}
                className={`inline-flex items-center justify-center px-4 py-2 pb-1 transition-all duration-300 group !text-sm !font-normal !font-sans ${
                  activeTab === tab.name
                    ? "!text-white hover:text-gray-300 !border-b-2 !border-[#1DE4D4]"
                    : "!text-gray-400 hover:text-gray-300"
                }`}
                style={{}}
              >
                {tab.icon && (
                  <div
                    className={`mr-2 ${
                      activeTab === tab.name
                        ? "!text-blue-500"
                        : "!text-gray-400"
                    }`}
                  >
                    {tab.icon}
                  </div>
                )}
                {tab.displayName}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
